import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

// Remplacer par vos propres configurations Firebase
const firebaseConfig = {
    apiKey: "AIzaSyBGuH78VqmFISJEfVxNFeWUxbVSLy2Op6w",
    authDomain: "ks-biblequiz.firebaseapp.com",
    projectId: "ks-biblequiz",
    storageBucket: "ks-biblequiz.firebasestorage.app",
    messagingSenderId: "29054795030",
    appId: "1:29054795030:web:634f498873380bbec36437",
    measurementId: "G-NV6MC27E3M"
}

// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Exporter les services
export const auth = getAuth(app);
export const database = getDatabase(app);
export default app;
